import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'
// import Parse from 'parse'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.config.productionTip = false

new Vue({
  router,
  render: function (h) { return h(App) },
  created () {
    // Parse.initialize("", "");
    // Parse.serverURL = "";
  }
}).$mount('#app');
